/* tp.js - themed pages (22 Oct 2026). Behaviour for sections/tp-*.liquid and snippets/tp-card.liquid. No dependencies.
   Loaded once with defer from the layout's <head> on themed pages (snippets/tp-assets.liquid); on any other page each
   themed section loads it, and window.__tpBoot keeps it to one copy running.

   1. Chapter bar: built from the sections on the page that carry [data-tp-nav] (chapters, plus the set-up and guides
      sections when they are given a bar name), in page order, and placed right after the hero (a direct child of
      <main>, so it can stick for the whole page). Chapters are numbered 01, 02 ... ([data-tp-chapter] [data-tp-num]).
      The active tab follows the scroll. It sits under the site's own sticky bar when that is showing (.eu-dsb on
      desktop, .eu-psb on phones), via --tp-top on <html>, and below the header's menus (z-index 7 < the header's 8).
   2. Counts for big collections: elements with [data-tp-stat="<handle>"] are filled from
      /collections/<handle>?view=tp-stat&page=n (templates/collection.tp-stat.liquid): products in stock, lowest price,
      budget bands, brand counts. Cached for 10 minutes in sessionStorage. Small collections are counted in Liquid.
   3. Packshots ([data-tp-trim]): each product picture is measured once on a small canvas (its visible box: not white,
      not transparent) and scaled so the product fills its plate like its neighbours, at most 2.6 times the plain fit.
      Cached per picture in sessionStorage. Without JS the picture simply sits contained in its plate.
   4. Add to basket (form[data-tp-atc]): the homepage cards' contract (eur-home-o2.js): POST /cart/add.js, then the
      theme's own product:added event (header count and mini-cart), the button shows "Added" for 2 seconds and a
      polite live region says so. Without JS the form posts to /cart/add.
   5. Complete the set-up ([data-tp-set]): each row is a real checkbox (click, Space); the running total, the humm line
      and "Add n items" follow, and one /cart/add.js call adds the main product (when it has no options and isn't a
      pre-order) and every ticked item. The msg line is the set-up's own live region (role=status).
   Theme editor: re-runs on shopify:section:load / unload. */
(function () {
  'use strict';
  if (window.__tpBoot) return;
  window.__tpBoot = true;
  var d = document, w = window, root = d.documentElement;
  function all(sel, ctx) { return Array.prototype.slice.call((ctx || d).querySelectorAll(sel)); }
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function reduced() { return !!(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches); }
  /* money as the theme prints it: money_without_trailing_zeros (keep = money, always with cents) */
  function eur(c, keep) {
    var f = (Math.round(c) / 100).toFixed(2).split('.');
    var s = '€' + f[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (keep || f[1] !== '00') ? s + '.' + f[1] : s;
  }
  function hummHtml(c) {
    if (c < 500) return '';
    if (c < 50000) return '<b>3&nbsp;&times;&nbsp;' + eur(Math.round(c / 3), true) + '</b> interest-free';
    return 'Spread the cost';
  }
  function bk(s) { return String(s || '').toLowerCase().replace(/['’\s\-.]/g, ''); }
  function brandName(v) { return /^de ?longhi$/i.test(v) ? "De'Longhi" : v; }
  var live = null;
  function announce(t) {
    if (!live) {
      live = d.createElement('div');
      live.className = 'tp-sr'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite');
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap';
      d.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = t; }, 60);
  }

  /* ------------------------------------------------------------ 1. chapter bar */
  var bar = null, barLinks = [], spyRaf = 0;
  /* the site's own sticky bars: .eu-dsb (desktop, from 1000px) and .eu-psb (phones, under 750px) slide in once the
     header has scrolled away; the chapter bar then sits right under the one that is showing */
  var STICKY = ['.eu-dsb', '.eu-psb'];
  function topOffset() {
    var h = 0;
    STICKY.forEach(function (sel) {
      var el = d.querySelector(sel);
      if (!el || !el.classList.contains('is-on') || w.getComputedStyle(el).display === 'none') return;
      h = Math.max(h, el.offsetHeight || 0);
    });
    return Math.max(0, Math.round(h));
  }
  function setTop() { root.style.setProperty('--tp-top', topOffset() + 'px'); }
  function buildBar() {
    var nums = 0;
    all('[data-tp-chapter]').forEach(function (sec) {
      nums++;
      var n = sec.querySelector('[data-tp-num]');
      if (n) n.textContent = (nums < 10 ? '0' : '') + nums;
    });
    all('nav.tp-bar').forEach(function (n) { n.parentNode.removeChild(n); });
    bar = null; barLinks = [];
    var slot = d.querySelector('[data-tp-bar-slot]');
    if (!slot) return;
    var items = all('[data-tp-nav]').filter(function (s) { return s.id && s.getAttribute('data-tp-nav'); });
    if (!items.length) { slot.style.display = 'none'; return; }
    var nav = d.createElement('nav');
    nav.className = 'tp tp-bar';
    nav.setAttribute('aria-label', 'On this page');
    var h = '<div class="tp-w"><div class="tp-bar__in">';
    items.forEach(function (sec, i) {
      var c = sec.getAttribute('data-tp-count') || '', js = /^js:/.test(c);
      h += '<a href="#' + esc(sec.id) + '" data-t="' + esc(sec.id) + '"' + (i === 0 ? ' class="is-on" aria-current="true"' : '') + '>' + esc(sec.getAttribute('data-tp-nav')) +
        (js ? '<span data-tp-stat="' + esc(c.slice(3)) + '" data-tp-k="nav" hidden></span>' : (c !== '' ? '<span>' + esc(c) + '</span>' : '')) + '</a>';
    });
    nav.innerHTML = h + '</div></div>';
    var host = slot.closest('.shopify-section') || slot.parentNode;
    host.parentNode.insertBefore(nav, host.nextSibling);
    slot.style.display = 'none';
    bar = nav;
    barLinks = all('a', nav);
    fillStats(nav);
    spy();
  }
  function spy() {
    spyRaf = 0;
    if (!bar || !barLinks.length) return;
    var limit = bar.getBoundingClientRect().bottom + 48, on = barLinks[0];
    barLinks.forEach(function (a) {
      var t = d.getElementById(a.getAttribute('data-t'));
      if (t && t.getBoundingClientRect().top <= limit) on = a;
    });
    barLinks.forEach(function (a) {
      var is = a === on;
      if (a.classList.contains('is-on') !== is) {
        a.classList.toggle('is-on', is);
        if (is) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      }
    });
    /* keep the active tab in view inside the bar (phones), without moving the page */
    var sc = on.parentNode;
    if (sc.scrollWidth > sc.clientWidth + 1) {
      var l = on.offsetLeft - sc.offsetLeft, r = l + on.offsetWidth;
      if (l < sc.scrollLeft + 16) sc.scrollLeft = Math.max(0, l - 16);
      else if (r > sc.scrollLeft + sc.clientWidth - 16) sc.scrollLeft = r - sc.clientWidth + 16;
    }
  }
  function onScroll() { if (!spyRaf) spyRaf = w.requestAnimationFrame(spy); }
  function onAnchorClick(e) {
    var a = e.target && e.target.closest ? e.target.closest('a[href^="#tp-"]') : null;
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey) return;
    var t = d.getElementById(a.getAttribute('href').slice(1));
    if (!t) return;
    e.preventDefault();
    setTop();
    t.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'start' });
    if (w.history && history.replaceState) history.replaceState(null, '', '#' + t.id);
  }

  /* ------------------------------------------------------------ 2. counts for big collections */
  var SC = {}, SKEY = 'tp-stat-1:';
  function stat(h) {
    if (SC[h]) return SC[h];
    SC[h] = new Promise(function (res) {
      try {
        var c = JSON.parse(w.sessionStorage.getItem(SKEY + h) || 'null');
        if (c && Date.now() - c.t < 600000) { res(c.s); return; }
      } catch (e) {}
      var acc = [], n = 0;
      function page(i) {
        fetch('/collections/' + encodeURIComponent(h) + '?view=tp-stat&page=' + i, { credentials: 'same-origin' })
          .then(function (r) { if (!r.ok) throw r; return r.text(); })
          .then(function (t) {
            var j = JSON.parse(t.trim());
            n = j.n; acc = acc.concat(j.a || []);
            if (j.page < j.pages && i < 12) { page(i + 1); return; }
            var s = { n: n, a: acc };
            try { w.sessionStorage.setItem(SKEY + h, JSON.stringify({ t: Date.now(), s: s })); } catch (e) {}
            res(s);
          })
          .catch(function () { res(null); });
      }
      page(1);
    });
    return SC[h];
  }
  function applyStat(el, s) {
    var k = el.getAttribute('data-tp-k'), a = s.a, n = a.length, min = 0;
    a.forEach(function (x) { if (!min || x[0] < min) min = x[0]; });
    if (k === 'paren' || k === 'nav') {
      if (n > 0) { el.textContent = k === 'paren' ? ' (' + n + ')' : String(n); el.hidden = false; }
    } else if (k === 'from') {
      if (n > 0) {
        all('[data-tp-v="min"]', el).forEach(function (e) { e.textContent = eur(min); });
        all('[data-tp-v="n"]', el).forEach(function (e) { e.textContent = n; });
        all('[data-tp-v="products"]', el).forEach(function (e) { e.textContent = n === 1 ? 'product' : 'products'; });
        el.hidden = false;
      }
    } else if (k === 'band') {
      var lo = +el.getAttribute('data-lo') || 0, hi = el.getAttribute('data-hi') ? +el.getAttribute('data-hi') : Infinity;
      el.textContent = a.filter(function (x) { return x[0] >= lo && x[0] < hi; }).length + ' in stock';
    } else if (k === 'vendor') {
      var v = String(el.getAttribute('data-vendor') || '').toLowerCase();
      el.textContent = a.filter(function (x) { return String(x[1]).toLowerCase() === v; }).length;
    } else if (k === 'brands') {
      var only = el.getAttribute('data-only') || '', base = el.getAttribute('data-base') || '', cnt = {}, names = [];
      a.forEach(function (x) { if (!cnt[x[1]]) { cnt[x[1]] = 0; names.push(x[1]); } cnt[x[1]]++; });
      if (only) names = names.filter(function (v) { return only.indexOf(',' + bk(v) + ',') > -1; });
      names.sort(function (p, q) { var P = brandName(p).toLowerCase(), Q = brandName(q).toLowerCase(); return P < Q ? -1 : P > Q ? 1 : 0; });
      el.innerHTML = names.map(function (v) {
        return '<a class="tp-brand" href="' + esc(base) + '?page=1&amp;rb_stock_status=In%20Stock&amp;rb_vendor=' + encodeURIComponent(v) + '">' + esc(brandName(v)) + '<span class="tp-sr">, </span><span>' + cnt[v] + '</span><span class="tp-sr"> in stock</span></a>';
      }).join('');
    }
  }
  function fillStats(ctx) {
    all('[data-tp-stat]', ctx).forEach(function (el) {
      if (el.__tpStat) return;
      el.__tpStat = true;
      stat(el.getAttribute('data-tp-stat')).then(function (s) { if (s) applyStat(el, s); });
    });
  }

  /* ------------------------------------------------------------ 3. packshot fit */
  var TKEY = 'tp-trim-1', tcache = {}, tsaveT = 0;
  try { tcache = JSON.parse(w.sessionStorage.getItem(TKEY) || '{}') || {}; } catch (e) { tcache = {}; }
  function tsave() { clearTimeout(tsaveT); tsaveT = setTimeout(function () { try { w.sessionStorage.setItem(TKEY, JSON.stringify(tcache)); } catch (e) {} }, 800); }
  function tkey(u) { return String(u).replace(/^https?:/, '').replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, ''); }
  function measure(src, cb) {
    var k = tkey(src);
    if (Object.prototype.hasOwnProperty.call(tcache, k)) { cb(tcache[k]); return; }
    var p = new Image();
    p.crossOrigin = 'anonymous';
    p.onload = function () {
      var b = null;
      try {
        var nw = p.naturalWidth, nh = p.naturalHeight, s = Math.min(1, 200 / Math.max(nw, nh));
        var W = Math.max(1, Math.round(nw * s)), H = Math.max(1, Math.round(nh * s));
        var cv = d.createElement('canvas'); cv.width = W; cv.height = H;
        var cx = cv.getContext('2d', { willReadFrequently: true });
        cx.drawImage(p, 0, 0, W, H);
        var px = cx.getImageData(0, 0, W, H).data, x0 = W, y0 = H, x1 = -1, y1 = -1;
        for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) {
          var i = (y * W + x) * 4;
          if (px[i + 3] < 24 || (px[i] > 240 && px[i + 1] > 240 && px[i + 2] > 240)) continue;
          if (x < x0) x0 = x; if (x > x1) x1 = x; if (y < y0) y0 = y; if (y > y1) y1 = y;
        }
        if (x1 >= x0 && y1 >= y0) {
          b = [+(x0 / W).toFixed(4), +(y0 / H).toFixed(4), +((x1 - x0 + 1) / W).toFixed(4), +((y1 - y0 + 1) / H).toFixed(4)];
          if (b[2] > 0.97 && b[3] > 0.97) b = null;
        }
      } catch (e) { b = null; }
      tcache[k] = b; tsave(); cb(b);
    };
    p.onerror = function () { cb(null); };
    p.src = /[?&]width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=200') : src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
  }
  function place(img) {
    var b = img.__tpBox; if (!b) return;
    var pl = img.parentNode, P = pl.getBoundingClientRect();
    if (!P.width || !P.height || !img.naturalWidth) return;
    img.style.left = img.style.top = img.style.width = img.style.height = '';
    var tx = img.offsetLeft, ty = img.offsetTop, tw = img.offsetWidth, th = img.offsetHeight;
    var nw = img.naturalWidth, nh = img.naturalHeight;
    var s0 = Math.min(tw / nw, th / nh), s = Math.min(tw / (b[2] * nw), th / (b[3] * nh), s0 * 2.6);
    var iw = nw * s, ih = nh * s;
    var left = tx + tw / 2 - (b[0] + b[2] / 2) * iw, top = ty + th / 2 - (b[1] + b[3] / 2) * ih;
    img.style.left = (left / P.width * 100) + '%';
    img.style.top = (top / P.height * 100) + '%';
    img.style.width = (iw / P.width * 100) + '%';
    img.style.height = (ih / P.height * 100) + '%';
    img.style.objectFit = 'fill';
  }
  function trim(img) {
    if (img.__tpTrim) return;
    img.__tpTrim = true;
    function go() {
      measure(img.currentSrc || img.src, function (b) { img.__tpBox = b; if (b) place(img); });
    }
    if (img.complete && img.naturalWidth) go(); else img.addEventListener('load', go, { once: true });
  }
  function initTrim(ctx) { all('img[data-tp-trim]', ctx).forEach(trim); }
  var rzT = 0;
  function onResize() {
    clearTimeout(rzT);
    rzT = setTimeout(function () { all('img[data-tp-trim]').forEach(place); setTop(); spy(); }, 150);
  }

  /* ------------------------------------------------------------ 4. Add to basket (the homepage cards' contract) */
  function cartAddUrl() { return ((w.routes && w.routes.cartAddUrl) || '/cart/add').replace(/\.js$/, '') + '.js'; }
  function added(qty) {
    root.dispatchEvent(new CustomEvent('product:added', { bubbles: true, detail: { button: null, variant: null, quantity: qty || 1, productAdded: true } }));
  }
  function flash(btn, cls, ms) {
    btn.classList.add(cls);
    setTimeout(function () { btn.classList.remove(cls); }, ms);
  }
  function onSubmit(e) {
    var form = e.target && e.target.closest ? e.target.closest('form[data-tp-atc]') : null;
    if (!form || !w.fetch) return;
    var btn = form.querySelector('[type=submit]'), idEl = form.querySelector('input[name=id]');
    if (!btn || !idEl) return;
    e.preventDefault();
    if (btn.disabled) return;
    var title = btn.getAttribute('data-title') || 'Item';
    btn.disabled = true;
    fetch(cartAddUrl(), {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: parseInt(idEl.value, 10), quantity: 1 })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function () {
      btn.disabled = false;
      flash(btn, 'is-done', 2000);
      announce(title + ' added to your basket');
      added(1);
    }).catch(function () {
      btn.disabled = false;
      flash(btn, 'is-error', 3000);
      announce('Sorry, ' + title + ' could not be added. Try again.');
    });
  }

  /* ------------------------------------------------------------ 5. Complete the set-up */
  /* Each row is a real checkbox inside a label; the energy label and information sheet links sit outside the label,
     so they open normally by mouse and keyboard. The main product counts only when it can go in the basket with the
     items (data-quick="1"); otherwise it keeps its own button and stays out of the total, the count and humm. */
  function initSet(set) {
    if (set.__tp) return;
    set.__tp = true;
    var anchor = set.querySelector('[data-tp-anchor]'), opts = all('.tp-opt[data-tp-opt]', set);
    var btn = set.querySelector('[data-tp-addall]'), msg = set.querySelector('[data-tp-msg]');
    if (!anchor || !btn) return;
    var aq = anchor.getAttribute('data-quick') === '1';
    function box(o) { return o.querySelector('input.tp-opt__in'); }
    function recalc() {
      var tot = aq ? (+anchor.getAttribute('data-price') || 0) : 0, n = aq ? 1 : 0;
      opts.forEach(function (o) {
        var b = box(o), on = !!(b && b.checked);
        o.classList.toggle('is-on', on);
        if (on) { tot += +o.getAttribute('data-price') || 0; n++; }
        var ln = set.querySelector('.tp-sum li[data-for="' + o.getAttribute('data-tp-opt') + '"]');
        if (ln) ln.hidden = !on;
      });
      all('[data-tp-n]', set).forEach(function (e) { e.textContent = n; });
      all('[data-tp-items]', set).forEach(function (e) { e.textContent = n === 1 ? 'item' : 'items'; });
      var t = set.querySelector('[data-tp-total]'); if (t) t.textContent = eur(tot);
      var hm = set.querySelector('[data-tp-humm]');
      if (hm) { hm.hidden = tot < 500; var ht = hm.querySelector('[data-tp-humm-t]'); if (ht) ht.innerHTML = hummHtml(tot); }
      btn.disabled = n === 0;
    }
    opts.forEach(function (o) {
      var b = box(o);
      if (!b) return;
      b.addEventListener('change', recalc);
      /* a click on the price side of the row (not a link) ticks it too, like the label side */
      o.addEventListener('click', function (e) {
        if (e.target.closest('a, label, input')) return;
        b.checked = !b.checked; recalc();
      });
    });
    btn.addEventListener('click', function () {
      if (btn.disabled || !w.fetch) return;
      var items = [];
      if (aq) items.push({ id: +anchor.getAttribute('data-variant'), quantity: 1 });
      opts.forEach(function (o) { var b = box(o); if (b && b.checked) items.push({ id: +o.getAttribute('data-variant'), quantity: 1 }); });
      if (!items.length) return;
      btn.disabled = true;
      fetch(cartAddUrl(), {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw r; return r.json(); }).then(function () {
        btn.disabled = false;
        flash(btn, 'is-done', 2500);
        var t = items.length + (items.length === 1 ? ' item' : ' items') + ' added to your basket.';
        if (msg) msg.textContent = t;
        added(items.length);
      }).catch(function () {
        btn.disabled = false;
        flash(btn, 'is-error', 3000);
        var t = 'Sorry, those items could not be added. Try again, or add them one by one.';
        if (msg) msg.textContent = t;
      });
    });
    recalc();
  }

  /* ------------------------------------------------------------ boot */
  function init(ctx) {
    ctx = ctx || d;
    initTrim(ctx);
    fillStats(ctx);
    all('[data-tp-set]', ctx).forEach(initSet);
  }
  function boot() {
    setTop();
    buildBar();
    init(d);
    w.addEventListener('scroll', onScroll, { passive: true });
    w.addEventListener('resize', onResize);
    if ('MutationObserver' in w) STICKY.forEach(function (sel) {
      var el = d.querySelector(sel);
      if (el) new MutationObserver(function () { setTop(); }).observe(el, { attributes: true, attributeFilter: ['class'] });
    });
  }
  d.addEventListener('submit', onSubmit);
  d.addEventListener('click', onAnchorClick);
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  d.addEventListener('shopify:section:load', function (e) { init(e.target); buildBar(); });
  d.addEventListener('shopify:section:unload', function () { setTimeout(buildBar, 0); });
  d.addEventListener('shopify:section:reorder', function () { setTimeout(buildBar, 0); });
}());
